import Cookies from 'js-cookie'

import env from '@/utils/env'

export class TokenManage {
  private static instance: TokenManage

  /** sid cookie过期天数 */
  private static expires = 1 // 1天

  constructor () {
    if (TokenManage.instance === null) {
      TokenManage.instance = this
    }
    return TokenManage.instance
  }

  public readonly key: string = 'yinnho_webapi_sid'
  public readonly timeKey: string = 'yinnho_webapi_sid_expires'
  public readonly domain: string = env.dev ? '' : location.hostname

  get sid () {
    return Cookies.get(this.key) ?? ''
  }

  set sid (value: string) {
    if (!value) {
      Cookies.remove(this.key)
      Cookies.remove(this.timeKey)
    } else {
      const { expires } = TokenManage // 过期天数
      // 过期的准确时间戳
      const ms = expires * 86400 * 1000
      const expiresDate = Date.now() + ms

      Cookies.set(this.key, value, { expires, domain: this.domain })
      Cookies.set(this.timeKey, expiresDate.toString(), { expires, domain: this.domain })
    }
  }

  get expires (): number | undefined {
    const expiresDate = Cookies.get(this.timeKey)
    if (expiresDate !== undefined) {
      return Number(expiresDate)
    }
    return undefined
  }

  /** 更新sid有效期 */
  update () {
    this.sid = Cookies.get(this.key) || ''
  }

  /** 删除sid */
  del () {
    this.sid = ''
  }
}

export default new TokenManage()
